import { getAccessToken } from './auth/credentialsStorage';

export const getUrl = (url: string, auth?: boolean) => {
    const [, oldParams] = url.split('?');
    const urlParams = new URLSearchParams(oldParams);
    const accessToken = getAccessToken();

    if (auth && accessToken) {
        urlParams.set('accessToken', accessToken);
    }
    urlParams.set('silentConsent', 'true');
    const [targetUrl] = url.split('?');
    return `${targetUrl}?${urlParams.toString()}`;
};

const printUrl = (
    targetUrl: string,
    options?: {
        auth?: boolean;
        headerTemplate?: string;
        footerTemplate?: string;
        margins?: {
            left?: string;
            top?: string;
            right?: string;
            bottom?: string;
        };
    }
) => {
    const { auth, headerTemplate, footerTemplate, margins } = {
        auth: false,
        ...options,
    };
    const searchParams = new URLSearchParams({
        ...(APP_ENV.BASE_AUTH_USER && {
            baseAuthUser: APP_ENV.BASE_AUTH_USER,
            baseAuthPassword: APP_ENV.BASE_AUTH_PASSWORD,
        }),
        url: getUrl(targetUrl, auth),
        ...(headerTemplate && {
            headerTemplate,
        }),
        ...(footerTemplate && {
            footerTemplate,
        }),
        ...(margins && {
            margins: JSON.stringify(margins),
        }),
    });
    const finalUrl = `https://pdf.hostettler.com/?${searchParams.toString()}`;

    window.open(finalUrl, '_blank');
};

export default printUrl;
